import {
    SET_FLEET_ITEM_CANCEL,
    SET_ASSET_FLEET_ITEM_CANCEL
} from "./FleetItemCancelType"

const initialState = {
    FleetItemCancel: {},
    assetFleetItemCancel: {}
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_FLEET_ITEM_CANCEL:
            return {
                ...state,
                FleetItemCancel: action.FleetItemCancel
            };
            case SET_ASSET_FLEET_ITEM_CANCEL:
            return {
                ...state,
                assetFleetItemCancel: action.assetFleetItemCancel
            };
        default:
            return state;
    }
};

export default reducer;